import Vue from 'vue'
import App from './App.vue'
import router from './router'
import wow from 'wowjs'
import {
  Backtop,
  Breadcrumb,
  BreadcrumbItem,
  Carousel,
  CarouselItem,
  Pagination,
  Menu,
  MenuItem,
  MenuItemGroup,
  Submenu,
  Option,
  Select,
  Message
} from 'element-ui'

import 'lib-flexible/flexible.js' //淘宝flex
import '@/assets/css/global.css' // 全局样式
import 'element-ui/lib/theme-chalk/index.css' // ElementUI样式
import 'animate.css/animate.min.css'
import 'animate.css'
// import 'wowjs/css/libs/animate.css' //引入wow.js
// import wow from 'wowjs'
// Vue.prototype.$wow = wow


Vue.use(Backtop)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Pagination)
Vue.use(Submenu)
Vue.use(Option)
Vue.use(Select)
Vue.component(Message)
Vue.prototype.$message = Message
Vue.prototype.$wow = wow
Vue.config.productionTip = false

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app')
